(ns frontend.ui.component.lp-portal.report.component.image.view
  (:require
   [common.util :as cu]
   [frontend.ui.component.lp-portal.voima-components.card.view :as card]
   [frontend.ui.component.lp-portal.voima-components.text-content.view :as text-content]
   [frontend.ui.component.image-cropper.view :as image-cropper]))

(defn image
  [label
   {:keys [_rich-content _rich-content-path rich-image-path image] :as data}
   {:keys [_edit-mode? save-text logo-target-width logo-target-height min-zoom] :as props} logo?]
  (let [removed-since-empty? (cu/blank-value? image)]
    (if (and (not (:edit-mode? props))
             removed-since-empty?)
      nil
      [card/card
       {:title  label
        :removed-since-empty? removed-since-empty?
        :logo?  logo?
        :image? true}
       [:<>
        (if-not (cu/blank-value? image)
          [:div
           {:style {:display        :flex
                    :flex-direction :row
                    :position       "relative"
                    :margin-top     (when (and (cu/blank-value? label) (not logo?))
                                      "-20px")}}

           [:img
            {:src   image
             :style {:max-width "100%"}}]
           (when (:edit-mode? props)
             [:i.fal.fa-trash-alt
              {:on-click (fn [_e]
                           (save-text rich-image-path ""))
               :style    {:margin-left "5px"
                          :cursor      "pointer"}}])]
          [image-cropper/modal-image-cropper
           (if logo?
             {:target-height (or logo-target-height 100)
              :target-width  (or logo-target-width 250)
              :min-zoom      min-zoom
              :round?        false
              :on-cropped    (fn [e]
                               (save-text rich-image-path e))
              :size          :xs}
             {:target-height 300
              :target-width  550
              :round?        false
              :on-cropped    (fn [e]
                               (save-text rich-image-path e))
              :size          :xs})])

        (when-not logo?
          [:div {:style {:margin-top "1rem"}}
           (when-not (or removed-since-empty? (:hide-footnote? props))
             (text-content/optional-footnote data props))])]])))
